angular.module('dentalLinks')
.controller('UserAddressesController', ['$scope', 'User',
    function ($scope, User) {
        $scope.addressIds = User.addressIds({ id: $scope.user.id });

        /**
         * Toggle selectedItem.id in $scope.addressIds.
         * Call User.updateAddressIds() to save.
         * @param {int} addressId 
         */
        $scope.toggleAddresses = function (addressId) {
            if ($scope.addressIds.indexOf(addressId) === -1) {
                $scope.addressIds.push(addressId);
            } else {
                $scope.addressIds.splice($scope.addressIds.indexOf(addressId), 1);
            }
            console.log('UserAddressesController $scope.addressIds: ', $scope.addressIds);

            User.updateAddressIds({ id: $scope.user.id }, $scope.addressIds);
        };

    }]);
